module.exports = __webpack_public_path__ + "img/bk_13.a4bc4bc7.png";